// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_1l-7";
export var adjustableWidthBorderHeld = "_1l-8";
export var arrow = "_1l-3";
export var arrowButton = "_1l-4";
export var headerCell = "_1l-0";
export var help = "_1l-2";
export var icon = "_1l-1";
export var iconWrapper = "_1l-6";
export var noBorder = "_1l-b";
export var nonAdjustableWidthBorder = "_1l-9";
export var nonAdjustableWidthBorderHeld = "_1l-a";
export var textButton = "_1l-5";